import React from "react";
import { useSelector } from "react-redux";
import { Box, Text } from "@chakra-ui/react";

/**
 * DemoModeBanner - Simplified banner indicating demo mode is active.
 * No step counter, no "End Demo" button (that's now a floating button).
 */
const DemoModeBanner = () => {
  const currentStep = useSelector((state) => state.demo.currentStep);
  return (
    <Box bg="purple.50" py={1} textAlign="center" data-demo-step={currentStep}>
      <Text
        fontSize="xs"
        fontWeight="500"
        color="purple.600"
        fontFamily="Geist, sans-serif"
      >
        Demo Mode
      </Text>
    </Box>
  );
};

export default DemoModeBanner;
